import React, { useState, useEffect } from "react";
import AgendamentosSemana from "./AgendamentosSemana";
import ValoresMensal from "./ValoresMensal";

import CardResumo from "./CardResumo";

export default function DashboardEmpresas({ dataSelecionada }) {
  const [clientes, setClientes] = useState(0);
  const [agendamentos, setAgendamentos] = useState(0);

  return (
    <div className="ion-margin">
          <div className="row">
            <div className="col-6 col-sm-4">
              <CardResumo
                texto={"Clientes"}
                valor={clientes}
                icone={"ri-user-line"}
              />
            </div>
            <div className="col-6 col-sm-4">
              <CardResumo
                texto={"Agendamentos na semana"}
                valor={agendamentos}
                icone={"ri-calendar-line"}
              />
            </div>
            <div  className="col-12 col-sm-4">
            <AgendamentosSemana
              totalAgendamentos={(value) => setAgendamentos(value)}
              totalClientes={(value) => setClientes(value)}
              dataBusca={dataSelecionada}
            />
            <ValoresMensal
              totalAgendamentos={(value) => setAgendamentos(value)}
              totalClientes={(value) => setClientes(value)}
              dataBusca={dataSelecionada}
            />
            </div>
          </div>
        </div>
  );
}
